<template>
  <el-config-provider :locale="elementLocale">
    <div id="app">
      <router-view />
    </div>
  </el-config-provider>
</template>

<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import { useSettingsStore } from '@/stores/settings'
import { useUserStore } from '@/stores/user'
import { sseClient } from '@/utils/sse'

const { locale } = useI18n()

// Element Plus locale reactive switching
const elementLocale = computed(() => {
  return locale.value === 'en-US' ? en : zhCn
})

const settingsStore = useSettingsStore()
const userStore = useUserStore()

// 初始化主题
const initTheme = () => {
  const savedTheme = settingsStore.theme
  if (savedTheme) {
    document.documentElement.setAttribute('data-theme', savedTheme)
  }
}

// 初始化SSE连接
const initSSE = () => {
  if (userStore.token) {
    sseClient.connect()
  }
}

// 监听登录状态变化
watch(
  () => userStore.token,
  (newToken, oldToken) => {
    if (newToken && !oldToken) {
      // 登录成功，建立SSE连接
      sseClient.connect()
    } else if (!newToken && oldToken) {
      // 退出登录，断开SSE连接
      sseClient.disconnect()
    }
  }
)

// 应用初始化
onMounted(() => {
  initTheme()
  initSSE()
})

// 应用卸载时断开SSE
onUnmounted(() => {
  sseClient.disconnect()
})
</script>

<style lang="scss">
@use "@/assets/styles/variables.scss" as *;
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-size: 14px;
  color: #333;
  background-color: #f5f5f5;
}

// Element Plus 主题覆盖
.el-button--primary {
  --el-button-bg-color: #409eff;
  --el-button-border-color: #409eff;
}

.el-menu--horizontal {
  border-bottom: none !important;
}

// 自定义滚动条
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>